import React from "react";

export default function Btn() {
  return (
    <div>
      <button className="submitButton">
        <a href="#contact">
          <p className="featureBtnText"> Fale Conosco </p>
        </a>
      </button>
    </div>
  );
}
